import { Element } from "@xmpp/xml"
import PubSubEventParser from "./PubSubEventParser"
import LocationParser from "@/lib/locationParser"
import { TrailerLocation } from "@/reducers/trailerLocationsSlice"

export const TRAILER_GEOLOC_NODE = "urn:slickshift:trailer-geoloc:0"

const GEOLOC_NS = "http://jabber.org/protocol/geoloc"
const SLICKSHIFT_GEOLOC_NS = "urn:slickshift:geoloc"

// Parses one <item id="..."><geoloc>...</geoloc></item> of the trailer node.
// The payload is the same XEP-0080 geoloc GPS publishes for vehicles, plus a
// <label> in the slickshift namespace with the provider's name for the asset.
export const parseTrailerLocationItem = (
  item: Element,
): TrailerLocation | undefined => {
  const id = item.getAttr("id")
  if (!id) return

  const geoloc = item.getChild("geoloc", GEOLOC_NS)
  const location = geoloc ? LocationParser.parseGeoloc(geoloc) : undefined
  const label = geoloc?.getChildText("label", SLICKSHIFT_GEOLOC_NS) || undefined

  return { id, label, location }
}

export const TrailerLocationPubSubParser =
  new PubSubEventParser<TrailerLocation>(
    parseTrailerLocationItem,
    TRAILER_GEOLOC_NODE,
  )
